import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b0a8b038&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b0a8b038&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0a8b038')) {
      api.createRecord('b0a8b038', component.options)
    } else {
      api.reload('b0a8b038', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b0a8b038&", function () {
      api.rerender('b0a8b038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/transports/views/my/index.vue"
export default component.exports